import { Avatar, Typography, Box, Divider } from '@mui/material';
import React from 'react';
import { usePermissions } from '../../hooks/permissions/usePermissions';

interface UserAvatarProps {
  user: {
    username?: string;
    full_name?: string;
    role?: string;
  } | null;
}

/**
 * Get user-friendly permission level display
 */
const getPermissionLevel = (can: any): string => {
  if (can.configureChatModels || can.configureEmbedding || can.configureTextExtraction || can.configureSMTP) {
    return 'Administrator';
  }
  if (can.manageUsers || can.manageGroups) {
    return 'Moderator';
  }
  return 'Standard User';
};

export const UserAvatar: React.FC<UserAvatarProps> = React.memo(({ user }) => {
  const { can } = usePermissions();
  const permissionLevel = getPermissionLevel(can);

  return (
    <>
      <Box sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'primary.main',
        color: 'white',
      }}>
        <Avatar
          sx={{
            width: 60,
            height: 60,
            mb: 1,
            backgroundColor: 'white',
            color: 'primary.main',
            fontFamily: '"Roboto", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
            fontWeight: 500,
          }}
        >
          {user?.username?.charAt(0).toUpperCase() || 'U'}
        </Avatar>
        <Typography variant="h6">{user?.full_name || user?.username || 'User'}</Typography>
        <Typography variant="body2">{permissionLevel}</Typography>
      </Box>
      <Divider />
    </>
  );
});